import * as React from 'react';

import { Translate } from 'react-localize-redux';

import { StreamingPlatform } from '@common/types/data/streaming-platform';

import BoxHeader from '@components/layout/box-header';
import MotionOpacity from '@components/motion/motion-opacity';
import StreamingPlatformInputCtrl from '../streaming-platform-input';
import styled from 'styled-components';
import { ARTIST_PLATFORMS_LIST } from '../../../../../../common/types/artist/artist-platforms';

export type StreamingPlatformValidator = {
  errorMessage?: React.ReactNode;
};

interface StreamingPlatformCtrlProps {
  className?: string;
  platforms: (StreamingPlatform & StreamingPlatformValidator)[];
  title?: React.ReactNode;
  text?: React.ReactNode;
  disableSelect?: boolean;
  filterKeys: string[];
  lockChangeProfile?: boolean;
  onChange: (value?: StreamingPlatform[]) => void;
}

export const StreamingPlatformCtrl: React.FC<StreamingPlatformCtrlProps> = (
  props
) => {
  const handleChange = <T extends keyof StreamingPlatform>(
    i: number,
    key: T,
    value: string
  ) => {
    props.onChange(
      props.platforms.map((platform, j) => {
        if (j === i) {
          return {
            ...platform,
            [key]: value,
          };
        }
        return platform;
      })
    );
  };

  const handleAddMore = () => {
    const platform = ARTIST_PLATFORMS_LIST.find(
      (p) => !props.platforms.some((s) => s.platform === p)
    );
    if (!platform) {
      return;
    }
    props.onChange(props.platforms.concat([{ platform, handle: '' }]));
  };

  const handleRemove = (i: number) => {
    props.onChange(props.platforms.filter((_, j) => j !== i));
  };

  const inFilterPlatform = (
    platform: StreamingPlatform & StreamingPlatformValidator
  ) => props.filterKeys.some((key) => key === platform.platform);

  if (props.filterKeys.length === props.platforms.length) {
    return null;
  }

  return (
    <div className={props.className}>
      <BoxHeader
        title={
          props.title ? (
            props.title
          ) : (
            <Translate id={'ARTIST_INFO.HOMEPAGE.TRACLINK.TITLE'} />
          )
        }
        text={
          props.text ? (
            props.text
          ) : (
            <Translate id={'ARTIST_INFO.HOMEPAGE.TRACLINK.SUBTITLE'} />
          )
        }
        noMargin
        buttonClose={false}
        onClick={() => handleAddMore()}
        className="mb-20"
      />

      <div>
        {props.platforms
          .filter((platform) => !inFilterPlatform(platform))
          .map((platform, i) => (
            <MotionOpacity
              key={`streaming-platforms-${i}`}
              className="streaming-platform-input"
            >
              {platform.errorMessage ? platform.errorMessage : null}
              <StreamingPlatformInputCtrl
                platform={platform.platform}
                disableSelect={props.disableSelect}
                value={platform.handle}
                onPlatformChange={(value) =>
                  handleChange<'platform'>(i, 'platform', value)
                }
                lockChangeProfile={props.lockChangeProfile}
                hasClose={false}
                onChange={(value) => handleChange<'handle'>(i, 'handle', value)}
                onClose={(ev) => {
                  ev.preventDefault();
                  ev.stopPropagation();
                  handleRemove(i);
                  return false;
                }}
              />
            </MotionOpacity>
          ))}
      </div>
    </div>
  );
};

export default styled(StreamingPlatformCtrl)`
  .streaming-platform-input {
    margin-top: 10px;
    &:first-child {
      margin-top: 10px;
    }
  }
`;
